// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"gIp4P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A PreviewTrigger displays a non-modal popover on hover, focus, or long press. Unlike a tooltip,
 * the popover may contain interactive content.
 */ parcelHelpers.export(exports, "PreviewTrigger", ()=>PreviewTrigger);
var _usePreviewTrigger = require("react-aria/usePreviewTrigger");
var _useFocusable = require("react-aria/private/interactions/useFocusable");
var _dialog = require("./Dialog");
var _popover = require("./Popover");
var _utils = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useTooltipTriggerState = require("react-stately/useTooltipTriggerState");
function PreviewTrigger(props) {
    let state = (0, _useTooltipTriggerState.useTooltipTriggerState)({
        ...props,
        delay: props.delay ?? 600,
        closeDelay: props.closeDelay ?? 200
    });
    let triggerRef = (0, _react.useRef)(null);
    let popoverRef = (0, _react.useRef)(null);
    let { triggerProps, popoverProps } = (0, _usePreviewTrigger.usePreviewTrigger)({
        ...props,
        triggerRef,
        popoverRef
    }, state);
    // The Popover and usePopover expect an OverlayTriggerState. Adapt the TooltipTriggerState (which
    // provides the warmup/cooldown delay behavior) to that interface.
    let overlayState = (0, _react.useMemo)(()=>({
            isOpen: state.isOpen,
            open: ()=>state.open(),
            close: ()=>state.close(),
            setOpen: (isOpen)=>isOpen ? state.open() : state.close(),
            toggle: ()=>state.isOpen ? state.close() : state.open(),
            point: null,
            setPoint: ()=>{}
        }), [
        state
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _dialog.OverlayTriggerStateContext),
                overlayState
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: 'PreviewTrigger',
                    triggerRef,
                    ref: popoverRef,
                    isNonModal: true,
                    // Skip enter/exit animations when swapping between previews during the warmup period.
                    shouldSkipAnimation: state.shouldSkipAnimation,
                    ...popoverProps
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _useFocusable.FocusableProvider), {
        ...triggerProps,
        ref: triggerRef
    }, props.children));
}

},{"react-aria/usePreviewTrigger":"5pnZk","react-aria/private/interactions/useFocusable":"8M8mb","./Dialog":"l2uUY","./Popover":"l4JC0","./utils":"bA6Cz","react":"a1TxN","react-stately/useTooltipTriggerState":"awE2t","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5pnZk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a preview trigger.
 * A preview trigger displays a popover on hover, focus, or long press. Unlike a
 * tooltip, the popover may contain interactive content.
 */ parcelHelpers.export(exports, "usePreviewTrigger", ()=>usePreviewTrigger);
var _focusWithoutScrolling = require("../utils/focusWithoutScrolling");
var _domfunctions = require("../utils/shadowdom/DOMFunctions");
var _focusScope = require("../focus/FocusScope");
var _useFocusVisible = require("../interactions/useFocusVisible");
var _domHelpers = require("../utils/domHelpers");
var _json = require("../../intl/previewtrigger/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _mergeProps = require("../utils/mergeProps");
var _react = require("react");
var _useEffectEvent = require("../utils/useEffectEvent");
var _useEvent = require("../utils/useEvent");
var _useHover = require("../interactions/useHover");
var _useId = require("../utils/useId");
var _useLocalizedStringFormatter = require("../i18n/useLocalizedStringFormatter");
var _useLongPress = require("../interactions/useLongPress");
var _useSafeArea = require("./useSafeArea");
function usePreviewTrigger(props, state) {
    let { triggerRef, popoverRef, isDisabled } = props;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/link-preview');
    let popoverId = (0, _useId.useId)();
    // Suppresses the next focus from reopening the preview (e.g. when restoring focus on Escape).
    let ignoreFocus = (0, _react.useRef)(false);
    // When opened via long press, move focus into the popover once it opens so touch screen readers
    // (e.g. VoiceOver) move their virtual cursor into the preview.
    let shouldFocusOnOpen = (0, _react.useRef)(false);
    // Whether the pointer is currently within the safe area (the trigger, the popover, or the region
    // between them). Tracked by useSafeArea below so the preview stays open while the pointer travels
    // from the link to the popover, even with closeDelay of 0.
    let pointerInSafeArea = (0, _react.useRef)(false);
    let isFocusVisible = (0, _react.useRef)(false);
    (0, _useFocusVisible.useFocusVisibleListener)((visible)=>{
        isFocusVisible.current = visible;
    }, []);
    // Cancel a pending close and keep the preview open.
    let keepOpen = (0, _useEffectEvent.useEffectEvent)(()=>state.open(true));
    // Close the preview unless something is still keeping it open: the pointer is within the safe
    // area, or focus is within the trigger or popover. During focus transitions the active element
    // may briefly be the body; the popover's focusin handler re-opens in that case (focus moving in).
    let checkClose = (0, _useEffectEvent.useEffectEvent)(()=>{
        if (pointerInSafeArea.current) return;
        let active = triggerRef.current ? (0, _domfunctions.getActiveElement)((0, _domHelpers.getOwnerDocument)(triggerRef.current)) : null;
        if (isFocusVisible.current && (triggerRef.current && (0, _domfunctions.nodeContains)(triggerRef.current, active) || popoverRef.current && (0, _domfunctions.nodeContains)(popoverRef.current, active))) return;
        state.close();
    });
    (0, _react.useEffect)(()=>{
        let popover = popoverRef.current;
        if (!state.isOpen || !popover || !shouldFocusOnOpen.current) return;
        // When opened via long press, move focus to the popover itself so touch screen readers move
        // their virtual cursor into the preview.
        shouldFocusOnOpen.current = false;
        (0, _focusWithoutScrolling.focusWithoutScrolling)(popover);
    }, [
        state.isOpen,
        popoverRef
    ]);
    let onHoverStart = ()=>{
        // Match useTooltipTrigger: only treat as hovered when the modality is actually a pointer.
        if ((0, _useFocusVisible.getInteractionModality)() === 'pointer') {
            pointerInSafeArea.current = true;
            state.open();
        }
    };
    let onHoverEnd = ()=>{
        // Before the preview opens, cancel a pending warmup if the pointer leaves the trigger. Once
        // open, the safe-area polygon (useSafeArea) governs closing as the pointer moves to the popover.
        if (!state.isOpen) {
            pointerInSafeArea.current = false;
            state.close();
        }
    };
    let onTriggerFocus = (e)=>{
        if (ignoreFocus.current) {
            ignoreFocus.current = false;
            return;
        }
        // Prevent browser focusing the link on long press when focus is already in the popover.
        if (state.isOpen && e.relatedTarget === popoverRef.current) {
            (0, _focusWithoutScrolling.focusWithoutScrolling)(popoverRef.current);
            return;
        }
        if (isFocusVisible.current) // Open after the warmup delay on keyboard focus, not immediately like a tooltip. This way
        // tabbing quickly through the page doesn't open previews (and add their tab stops); the
        // delay ensures the user is actually interested in the link's details.
        state.open();
    };
    (0, _useEvent.useEvent)(triggerRef, 'react-aria-focus-scope-restore', (e)=>{
        e.preventDefault();
        ignoreFocus.current = true;
        triggerRef.current?.focus();
    });
    // Move focus from the link into the preview when the user presses Tab while it is open.
    // Tabbing back out of the popover is handled by the popover's own FocusScope.
    let onTriggerKeyDown = (e)=>{
        if (e.key === 'Tab' && !e.shiftKey && state.isOpen && popoverRef.current) {
            let walker = (0, _focusScope.getFocusableTreeWalker)(popoverRef.current, {
                tabbable: true
            });
            let first = walker.nextNode();
            if (first) {
                e.preventDefault();
                first.focus();
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            state.close(true);
        }
    };
    let { hoverProps } = (0, _useHover.useHover)({
        isDisabled,
        onHoverStart,
        onHoverEnd
    });
    let focusableProps = {
        onFocus: onTriggerFocus,
        onBlur: checkClose,
        onKeyDown: onTriggerKeyDown
    };
    // Only describe the long press interaction when the user is actually using touch, otherwise it
    // is confusing (e.g. a screen reader announcing "long press" while navigating with a keyboard).
    // null is the default before the user has interacted with anything.
    let modality = (0, _useFocusVisible.useInteractionModality)();
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    // Open the preview on long press on touch devices, since there is no hover. Move focus into the
    // popover once it opens so touch screen readers (e.g. VoiceOver) move their virtual cursor in.
    let { longPressProps } = (0, _useLongPress.useLongPress)({
        isDisabled,
        pointerType: 'touch',
        accessibilityDescription: shouldLongPress ? stringFormatter.format('longPressMessage') : undefined,
        onLongPress () {
            shouldFocusOnOpen.current = true;
            state.open(true);
        }
    });
    // Keep the preview open while the pointer is anywhere within the safe area connecting the link
    // and the popover, so moving the pointer between them (even diagonally) doesn't close it. This
    // works for any popover placement and even when closeDelay is 0.
    (0, _useSafeArea.useSafeArea)({
        triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        isDisabled,
        onSafeAreaChange: (isInSafeArea)=>{
            if (isInSafeArea === pointerInSafeArea.current) return;
            pointerInSafeArea.current = isInSafeArea;
            if (isInSafeArea) keepOpen();
            else checkClose();
        }
    });
    // oxlint-disable-next-line react/react-compiler
    let triggerProps = (0, _mergeProps.mergeProps)(focusableProps, hoverProps, longPressProps);
    let describedBy = [
        triggerProps['aria-describedby'],
        state.isOpen ? popoverId : null
    ].filter(Boolean).join(' ');
    return {
        triggerProps: {
            ...triggerProps,
            'aria-haspopup': 'dialog',
            'aria-expanded': state.isOpen,
            'aria-controls': state.isOpen ? popoverId : undefined,
            'aria-describedby': describedBy || undefined,
            style: {
                WebkitTouchCallout: 'none',
                // @ts-ignore
                WebkitUserDrag: 'none'
            }
        },
        popoverProps: {
            id: popoverId,
            onFocusWithin: keepOpen,
            onBlurWithin: checkClose
        }
    };
}

},{"../utils/focusWithoutScrolling":"98Wfp","../utils/shadowdom/DOMFunctions":"93ERU","../focus/FocusScope":"fNgMQ","../interactions/useFocusVisible":"9a2nM","../utils/domHelpers":"cOsVz","../../intl/previewtrigger/*.json":"fSCZg","../utils/mergeProps":"1CzGd","react":"a1TxN","../utils/useEffectEvent":"fVIcf","../utils/useEvent":"lMVDh","../interactions/useHover":"9zlAr","../utils/useId":"de3v3","../i18n/useLocalizedStringFormatter":"4LM0k","../interactions/useLongPress":"6QdMN","./useSafeArea":"fejLv","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fSCZg":[function(require,module,exports,__globalThis) {
const _temp0 = require("6b4f072cb30c61d5");
const _temp1 = require("10c7be404f1555b0");
const _temp2 = require("603971d3623af4d1");
const _temp3 = require("b028fbff41dfce5e");
const _temp4 = require("5a22beac8d435374");
const _temp5 = require("37f2869b6c02be8a");
const _temp6 = require("d594d25331f86d07");
const _temp7 = require("b89caa70b0a44884");
const _temp8 = require("912dd3910beb7236");
const _temp9 = require("5408420d532c5fa4");
const _temp10 = require("e68b72778da43a8e");
const _temp11 = require("58f254b86130fce4");
const _temp12 = require("3af0f175605cc451");
const _temp13 = require("1bd2271764e93b0a");
const _temp14 = require("70c159b4aeb9c4a7");
const _temp15 = require("2e633900b16724d8");
const _temp16 = require("e3ad44aa04c33c57");
const _temp17 = require("85dc73cae97e8803");
const _temp18 = require("d35e3a4e5235987");
const _temp19 = require("78e301b00687b433");
const _temp20 = require("9bb66d91f178a75d");
const _temp21 = require("b211bd006feb2190");
const _temp22 = require("d68bb6f8202447d2");
const _temp23 = require("fc19d9b1ef95011b");
const _temp24 = require("ba67342e422ae291");
const _temp25 = require("1072f3196815500d");
const _temp26 = require("c87029d430524822");
const _temp27 = require("d1b28cb49c4b7c66");
const _temp28 = require("afe0589da89b3fb6");
const _temp29 = require("889a0cff8011a230");
const _temp30 = require("c276c83a98bebd00");
const _temp31 = require("2a367dc87392cd51");
const _temp32 = require("f516dd74273280d3");
const _temp33 = require("c0850e5bbb2623bc");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"6b4f072cb30c61d5":"bPP2r","10c7be404f1555b0":"iC8rg","603971d3623af4d1":"it6dO","b028fbff41dfce5e":"kkOrt","5a22beac8d435374":"4dqSB","37f2869b6c02be8a":"9LRPD","d594d25331f86d07":"lW8G0","b89caa70b0a44884":"h8dxq","912dd3910beb7236":"jMF1B","5408420d532c5fa4":"2vETm","e68b72778da43a8e":"5ULZe","58f254b86130fce4":"aL5Kf","3af0f175605cc451":"1PeBX","1bd2271764e93b0a":"axzAm","70c159b4aeb9c4a7":"5NC0F","2e633900b16724d8":"fOEv8","e3ad44aa04c33c57":"7pEqf","85dc73cae97e8803":"fG29j","d35e3a4e5235987":"epYf4","78e301b00687b433":"dJBNL","9bb66d91f178a75d":"8e6L7","b211bd006feb2190":"cZFV7","d68bb6f8202447d2":"bf2U8","fc19d9b1ef95011b":"ikqTp","ba67342e422ae291":"bVltD","1072f3196815500d":"6fsIj","c87029d430524822":"6H2zW","d1b28cb49c4b7c66":"9lLnB","afe0589da89b3fb6":"dUown","889a0cff8011a230":"3GrEG","c276c83a98bebd00":"a7w96","2a367dc87392cd51":"dYHtG","f516dd74273280d3":"fqm9F","c0850e5bbb2623bc":"3tAIo"}],"bPP2r":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{645}\u{639}\u{627}\u{64A}\u{646}\u{629}`
};

},{}],"iC8rg":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{432}\u{430}\u{440}\u{438}\u{442}\u{435}\u{43B}\u{435}\u{43D} \u{43F}\u{440}\u{435}\u{433}\u{43B}\u{435}\u{434}`
};

},{}],"it6dO":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Podr\u{17E}en\xedm tla\u{10D}\xedtka otev\u{159}ete n\xe1hled`
};

},{}],"kkOrt":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Tryk og hold nede for at \xe5bne forh\xe5ndsvisningen`
};

},{}],"4dqSB":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Zum \xd6ffnen der Vorschau lange dr\xfccken`
};

},{}],"9LRPD":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3C0}\u{3C1}\u{3BF}\u{3B5}\u{3C0}\u{3B9}\u{3C3}\u{3BA}\u{3CC}\u{3C0}\u{3B7}\u{3C3}\u{3B7}`
};

},{}],"lW8G0":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Long press to open preview`
};

},{}],"h8dxq":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Pulse para abrir la vista previa`
};

},{}],"jMF1B":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Eelvaate avamiseks vajutage pikalt`
};

},{}],"2vETm":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Avaa esikatselu painamalla pitk\xe4\xe4n`
};

},{}],"5ULZe":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Appuyer longuement pour ouvrir la pr\xe9visualisation`
};

},{}],"aL5Kf":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E6}\u{5D5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5EA}\u{5E6}\u{5D5}\u{5D2}\u{5D4} \u{5DE}\u{5E7}\u{5D3}\u{5D9}\u{5DE}\u{5D4}`
};

},{}],"1PeBX":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Potreban je du\u{17E}i pritisak za otvaranje pregleda`
};

},{}],"axzAm":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Nyomja meg hosszan az el\u{151}n\xe9zet megnyit\xe1s\xe1hoz`
};

},{}],"5NC0F":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Tieni premuto per aprire l\u{2019}anteprima`
};

},{}],"fOEv8":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};

},{}],"7pEqf":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B20C}\u{B7EC} \u{BBF8}\u{B9AC} \u{BCF4}\u{AE30} \u{C5F4}\u{AE30}`
};

},{}],"fG29j":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Ilgai paspauskite, kad atvertum\u{117}te per\u{17E}i\u{16B}r\u{105}`
};

},{}],"epYf4":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Nospiediet un paturiet, lai skat\u{12B}tu priek\u{161}skat\u{12B}jumu`
};

},{}],"dJBNL":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Langt trykk for \xe5 \xe5pne forh\xe5ndsvisningen`
};

},{}],"8e6L7":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Lang indrukken voor voorvertoning`
};

},{}],"cZFV7":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj, aby otworzy\u{107} podgl\u{105}d`
};

},{}],"bf2U8":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Pressione e segure para abrir a visualiza\xe7\xe3o`
};

},{}],"ikqTp":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Prima e mantenha premido para abrir a pr\xe9-visualiza\xe7\xe3o`
};

},{}],"bVltD":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung pentru a deschide previzualizarea`
};

},{}],"6fsIj":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43F}\u{440}\u{435}\u{434}\u{432}\u{430}\u{440}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}`
};

},{}],"6H2zW":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `N\xe1h\u{13E}ad otvor\xedte dlh\xfdm stla\u{10D}en\xedm`
};

},{}],"9lLnB":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Dolg pritisk za odpiranje predogleda`
};

},{}],"dUown":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `Dugo pritisnite da biste otvorili pregled`
};

},{}],"3GrEG":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `H\xe5ll nedtryckt f\xf6r att \xf6ppna f\xf6rhandsgranskningen`
};

},{}],"a7w96":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\xd6nizlemeyi a\xe7mak i\xe7in uzun s\xfcre bas\u{131}l\u{131} tutun`
};

},{}],"dYHtG":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{456} \u{443}\u{442}\u{440}\u{438}\u{43C}\u{443}\u{439}\u{442}\u{435}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{43D}\u{456}\u{439} \u{43F}\u{435}\u{440}\u{435}\u{433}\u{43B}\u{44F}\u{434}`
};

},{}],"fqm9F":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{957F}\u{6309}\u{4EE5}\u{6253}\u{5F00}\u{9884}\u{89C8}`
};

},{}],"3tAIo":[function(require,module,exports,__globalThis) {
module.exports = {
    "longPressMessage": `\u{9577}\u{6309}\u{4EE5}\u{958B}\u{555F}\u{9810}\u{89BD}`
};

},{}],"fejLv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tracks whether the pointer is within a "safe area" connecting a trigger and its overlay, so the
 * overlay can stay open while the pointer moves between them. The safe area is the union of the
 * trigger rect, the overlay rect, and the convex hull connecting the two (a polygon), which works
 * for any placement of the overlay relative to the trigger.
 */ parcelHelpers.export(exports, "useSafeArea", ()=>useSafeArea);
var _domHelpers = require("../utils/domHelpers");
var _react = require("react");
var _useEffectEvent = require("../utils/useEffectEvent");
// A small amount of padding (in pixels) added around the trigger and overlay so the safe area is
// slightly forgiving of sub-pixel jitter and the gap between the elements.
const PADDING = 8;
function useSafeArea(options) {
    let { triggerRef, overlayRef, isOpen, isDisabled } = options;
    let onSafeAreaChange = (0, _useEffectEvent.useEffectEvent)(options.onSafeAreaChange);
    (0, _react.useEffect)(()=>{
        let trigger = triggerRef.current;
        if (isDisabled || !isOpen || !trigger) return;
        let onPointerMove = (e)=>{
            if (e.pointerType === 'touch') return;
            let point = {
                x: e.clientX,
                y: e.clientY
            };
            let triggerRect = trigger.getBoundingClientRect();
            let overlayRect = overlayRef.current?.getBoundingClientRect();
            onSafeAreaChange(isPointInSafeArea(point, triggerRect, overlayRect));
        };
        // If the pointer leaves the document entirely, it is no longer in the safe area.
        let onPointerLeave = ()=>onSafeAreaChange(false);
        let win = (0, _domHelpers.getOwnerWindow)(trigger);
        let doc = (0, _domHelpers.getOwnerDocument)(trigger);
        win.addEventListener('pointermove', onPointerMove);
        doc.documentElement.addEventListener('pointerleave', onPointerLeave);
        return ()=>{
            win.removeEventListener('pointermove', onPointerMove);
            doc.documentElement.removeEventListener('pointerleave', onPointerLeave);
        };
    }, [
        isDisabled,
        isOpen,
        triggerRef,
        overlayRef
    ]);
}
function isPointInSafeArea(point, triggerRect, overlayRect) {
    if (rectContains(triggerRect, point)) return true;
    if (!overlayRect) return false;
    if (rectContains(overlayRect, point)) return true;
    // Otherwise, check whether the point is within the convex hull connecting the two rects.
    let hull = convexHull([
        ...rectCorners(triggerRect),
        ...rectCorners(overlayRect)
    ]);
    return hull.length >= 3 && isPointInPolygon(point, hull);
}
function rectContains(rect, point) {
    return point.x >= rect.left - PADDING && point.x <= rect.right + PADDING && point.y >= rect.top - PADDING && point.y <= rect.bottom + PADDING;
}
function rectCorners(rect) {
    let left = rect.left - PADDING;
    let right = rect.right + PADDING;
    let top = rect.top - PADDING;
    let bottom = rect.bottom + PADDING;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
// Computes the convex hull of a set of points using the monotone chain algorithm.
function convexHull(points) {
    let sorted = points.slice().sort((a, b)=>a.x - b.x || a.y - b.y);
    if (sorted.length < 3) return sorted;
    let cross = (o, a, b)=>(a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);
    let lower = [];
    for (let p of sorted){
        while(lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], p) <= 0)lower.pop();
        lower.push(p);
    }
    let upper = [];
    for(let i = sorted.length - 1; i >= 0; i--){
        let p = sorted[i];
        while(upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], p) <= 0)upper.pop();
        upper.push(p);
    }
    lower.pop();
    upper.pop();
    return lower.concat(upper);
}
// Ray casting point-in-polygon test.
function isPointInPolygon(point, polygon) {
    let { x, y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        let xi = polygon[i].x;
        let yi = polygon[i].y;
        let xj = polygon[j].x;
        let yj = polygon[j].y;
        let intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}

},{"../utils/domHelpers":"cOsVz","react":"a1TxN","../utils/useEffectEvent":"fVIcf","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=PreviewTrigger.883618d7.js.map
